import React from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import PropTypes from "prop-types";

const TaskCreateBottom = ({ isSubmitting, setDisableDynamicDetailErrors, labels }) => {
  return (
    <div className="save-back-btn-container">
      <div className="save-back-btn">
        <Link to="/tasks">
          <Button className="right-btn btn-wide btn-outlined">Cancel</Button>
        </Link>
        <Button
          type="submit"
          onClick={() => {
            setDisableDynamicDetailErrors(false);
          }}
          className="left-btn btn-wide"
          variant="primary"
          disabled={isSubmitting}
        >
          {`Create ${labels?.TaskSingular ?? 'Task'}`}
        </Button>
      </div>
    </div>
  );
};

export default TaskCreateBottom;
TaskCreateBottom.propTypes = {
  isSubmitting: PropTypes.bool,
  setDisableDynamicDetailErrors: PropTypes.func,
  labels: PropTypes.shape({
    ProjectSingular: PropTypes.string,
    ProjectPlural: PropTypes.string,
    ProjectSingularPossessive: PropTypes.string,
    ProjectPluralPossessive: PropTypes.string,
    TaskSingular: PropTypes.string,
    TaskPlural: PropTypes.string,
    TaskSingularPossessive: PropTypes.string,
    TaskPluralPossessive: PropTypes.string,
    FormSingular: PropTypes.string,
    FormPlural: PropTypes.string,
    FormSingularPossessive: PropTypes.string,
    FormPluralPossessive: PropTypes.string,
  }),
};
